import type { InstallationContractState, InstallationContractStatus } from '../../types'
import { wonFormCheckInput, wonFormCheckLabel, wonFormCheckRow } from '../../formCheckClasses'

interface Props {
  isView: boolean
  contract: InstallationContractState
  updateContract: (patch: Partial<InstallationContractState>) => void
}

const InstallationContractSection: React.FC<Props> = ({ isView, contract, updateContract }) => {
  const setStatus = (status: InstallationContractStatus) => {
    updateContract({ status })
  }

  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>ด้านสัญญา</div>
        </div>
        <div className='card-body'>
          <p className='text-gray-700 mb-4'>สัญญาระหว่างบริษัทกับลูกค้า</p>
          <div className='d-flex flex-column gap-3'>
            <div className={wonFormCheckRow}>
              <input
                className={wonFormCheckInput}
                type='radio'
                name='won-install-contract'
                id='won-install-contract-signed'
                checked={contract.status === 'signed'}
                disabled={isView}
                onChange={() => setStatus('signed')}
              />
              <label className={wonFormCheckLabel} htmlFor='won-install-contract-signed'>
                เซ็นเรียบร้อย
              </label>
            </div>
            <div className={wonFormCheckRow}>
              <input
                className={wonFormCheckInput}
                type='radio'
                name='won-install-contract'
                id='won-install-contract-progress'
                checked={contract.status === 'in_progress'}
                disabled={isView}
                onChange={() => setStatus('in_progress')}
              />
              <label className={wonFormCheckLabel} htmlFor='won-install-contract-progress'>
                กำลังดำเนินการ
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationContractSection
